import React from "react";
import { Link } from "react-router-dom";
import { colors } from "../colors/cardColor";

const Card = (props) => {

    const [ color, setColor] = React.useState('');
    const [ imgUrl, setImg] = React.useState('');

    React.useEffect(async () => {
        const response = await fetch(`https://pokeapi.co/api/v2/pokemon/${props.name}`);
        const data = await response.json();

        setImg(data.sprites.other['official-artwork'].front_default);
        setColor(colors[data.types[0].type.name]);
    }, [props.name]);

    return (
        <Link to={`/pokemon/${props.name}`} >
            <div 
                className="pokemon-card d-flex justify-content-center flex-column"
                style={{backgroundColor:color}}
            >

                <div className="card-img-container mx-auto">
                    <div className="img-bg"></div>
                    <img 
                        src={imgUrl} 
                        alt={props.name}
                        className="pokemon-card-img"
                    />
                </div>
                
                <p className="pokemon-card-text">{props.name}</p>
            </div>
        </Link>
    );
}

export default Card;